import { getSiteOrigin } from './site';

/**
 * Build an absolute URL for meta tags (og:image, canonical, JSON-LD).
 * @param pathOrUrl Path starting with / or full URL
 */
export default function absoluteUrl(pathOrUrl: string): string {
  if (!pathOrUrl) return '';
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const origin = getSiteOrigin();
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${origin}${path}`;
}



// WEBPACK FOOTER //
// ./src/seo/absoluteUrl.ts